import { ModuleConfig } from '@/core/module';
import { invoiceProductRoutes } from './routes';
import { useInvoiceProductStore } from './stores/invoice-product-store';

export { useInvoiceProducts } from './hooks/useInvoiceProducts';
export { InvoiceProductForm } from './components/InvoiceProductForm';
export { InvoiceProductTable } from './components/InvoiceProductTable';
export * from './types';

export const InvoiceProductsModule: ModuleConfig = {
    name: 'invoice-products',
    routes: invoiceProductRoutes,
    stores: {
        invoiceProducts: useInvoiceProductStore
    },
    initialize: () => {
        console.log('Invoice Products module initialized');
    }
};
